module.exports = __webpack_public_path__ + "A189C633D9995E11BF8607170EC9A4B8customers3.eb8f24c4.png";